import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";

/**
 * Inline spinner + label, vertically centered with consistent spacing.
 * Drop-in replacement for the ad-hoc `<CircularProgress /> <Typography>Loading...</Typography>`
 * pairs that were misaligned and cramped across the app.
 */
export default function InlineLoader({ label = "Loading...", size = 22 }) {
  return (
    <div
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 12,
      }}
    >
      <CircularProgress size={size} style={{ color: "#9b51e0" }} />
      {label ? <Typography className="header-h3">{label}</Typography> : null}
    </div>
  );
}
